import { generatePath } from "../generatePath";

import type { ID } from "@constants";

export const path = {
  assignStaffToDoctor: {
    route: "/assign-staff-to-doctor",
    link: () => path.assignStaffToDoctor.route,
  },
  assignStaffToDoctorNew: {
    route: "/assign-staff-to-doctor/:id/:facilityId",
    link: (id: string, facilityId: ID) =>
      generatePath("/assign-staff-to-doctor/:id/:facilityId", {
        id,
        facilityId,
      }),
  },
  assignNewStaffToDoctor: {
    route: "/assign-staff-to-doctor/create",
    link: () => path.assignNewStaffToDoctor.route,
  },
  doctors: {
    route: "/assign-staff-to-doctor/doctors/:id/:facilityId",
    link: (id: string, facilityId: ID) =>
      generatePath("/assign-staff-to-doctor/doctors/:id/:facilityId", {
        id,
        facilityId,
      }),
  },
};
